import { ApolloClient } from '@apollo/client';
import { UnparsedQueryParams } from '~/providers/query-params/types';
import {
  Flex_ValidatePromoCodeQuery,
  Flex_ValidatePromoCodeQueryVariables,
} from '~/typings/graphql';
import { getPromoCodeFromParams } from '~/utils/provider-utils';
import { VALIDATE_PROMO_CODE as query } from './handle-promo-code.queries';

export { VALIDATE_PROMO_CODE } from './handle-promo-code.queries';

export const handlePromoCode = async ({
  apolloClient,
  params,
}: {
  apolloClient: ApolloClient<{}>;
  params: UnparsedQueryParams;
}) => {
  const promoCode = getPromoCodeFromParams(params);
  if (!promoCode || promoCode === '') return;

  const { data } = await apolloClient.query<
    Flex_ValidatePromoCodeQuery,
    Flex_ValidatePromoCodeQueryVariables
  >({
    query,
    variables: { promoCode },
  });

  return data?.validation.promoCode.isValid ? promoCode : undefined;
};
